import { render, staticRenderFns } from "./_SecondLevelMenuPanel.vue?vue&type=template&id=040a2aaa&"
import script from "./_SecondLevelMenuPanel.vue?vue&type=script&lang=ts&"
export * from "./_SecondLevelMenuPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('040a2aaa')) {
      api.createRecord('040a2aaa', component.options)
    } else {
      api.reload('040a2aaa', component.options)
    }
    module.hot.accept("./_SecondLevelMenuPanel.vue?vue&type=template&id=040a2aaa&", function () {
      api.rerender('040a2aaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/components/PowerbarNav/_SecondLevelMenuPanel.vue"
export default component.exports